import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";
import { getPrincipalMessage } from "../Service/Api";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Message = () => {
  // ✅ Fetch data with React Query
  const { data } = useQuery({
    queryKey: ["principalMessage"],
    queryFn: getPrincipalMessage,
  });

  // ✅ Fallback data if API returns nothing
  const emptyData = [
    {
      category: "Principal",
      title: "Principal Message",
      name: "Principal Name",
      message: `<p>No Message found.</p>`,
      image:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/profilethumb.png",
      attachments: [],
      link: "/PrincipalMessage",
    },
  ];

  // ✅ Determine actual data safely
  const messages = Array.isArray(data) && data.length > 0 ? data : emptyData;

  // ✅ Slick settings (prevent cloning issue)
  const settings = {
    dots: true,
    infinite: messages.length > 1, // ✅ only infinite if multiple slides
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: true,
  };

  // ✅ Loading and Error States

  return (
    <div className="message-slider-wrapper">
      {/* ✅ If only one message, skip slider */}
      {messages.length > 1 ? (
        <Slider {...settings}>
          {messages.map((item, index) => (
            <MessageCard key={index} item={item} />
          ))}
        </Slider>
      ) : (
        <MessageCard item={messages[0]} />
      )}
    </div>
  );
};

// ✅ Extracted clean sub-component for readability
const MessageCard = ({ item }) => {
  const imageUrl =
    item.attachments && item.attachments.length > 0
      ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`
      : item.image;

  return (
    <div className="message-container">
      <div className="messagebox">
        <div className="messagedesc">
          <div className="maintitle">
            <h3>{item.category}'s Message</h3>
          </div>
          <div className="msginfo">
            {typeof item.message === "string" ? (
              <div dangerouslySetInnerHTML={{ __html: item.message }} />
            ) : (
              <>{item.message}</>
            )}
          </div>
        </div>

        <div className="messageboximg">
          <p>
            {item.name} <span>{item.category}</span>
          </p>
        </div>
      </div>

      <div className="messageimg">
        <div className="testimonialimg">
          <LazyLoad>
            <img
              src={imageUrl}
              alt={item.name || "Principal"}
              className="img-fluid"
            />
          </LazyLoad>
        </div>
        <div className="mainbtn button">
          <Link to={`/${item.category.replace(/\s+/g, "-").toLowerCase()}`}>
            READ MORE
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Message;
